export default "__VITE_ASSET__Dbwtv9IY__"